// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"K7-z"};